/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsConfigAzureAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsConfigAzureAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsConfigAzureAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsConfigAzureAdvisorResource>): RecommendationForFinopsConfigAzureAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsConfigAzureAdvisorResource(), model);
        RecommendationForFinopsConfigAzureAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsConfigAzureAdvisorResource>): RecommendationForFinopsConfigAzureAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsConfigAzureAdvisorResource.newInstance(<RecommendationForFinopsConfigAzureAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsConfigAzureAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsConfigAzureAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsConfigAzureAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsConfigAzureAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
